import "twin.macro";
import React, { useEffect} from "react";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";

const Title = ({ title }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  return (
    <div tw="flex flex-col justify-center items-center mx-auto space-y-2 text-center">
      <p tw="font-bold text-white text-3xl">{title}</p>
      <div tw="flex ">
        <motion.div
          ref={ref}
          animate={controls}
          initial="hidden"
          variants={{
            visible: { opacity: 1, x: 0 },
            hidden: { opacity: 0, x: 100 },
          }}
          transition={{ duration: 1 }}
          tw="bg-red-600 w-32 h-1"
        >
          {" "}
        </motion.div>

        <div tw=" w-32 h-1"> </div>
      </div>
    </div>
  );
};

export default Title;
